<template>
  <span>
    <v-flex xs10>
      <vue-google-autocomplete :id="pickupType"
                               ref="address"
                               placeholder=" "
                               autofocus
                               :label="pickupType"
                               v-on:placechanged="getAddressData">
      </vue-google-autocomplete>

      <v-menu ref="menu"
              lazy
              :close-on-content-click="false"
              v-model="menu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-right="40"
              min-width="290px"
              :return-value.sync="date">
        <v-text-field slot="activator"
                      :label="pickupType"
                      v-model="date"
                      prepend-icon="event"
                      readonly></v-text-field>
        <v-date-picker v-model="date"
                       no-title
                       scrollable>
          <v-spacer></v-spacer>
          <v-btn flat
                 color="primary"
                 @click="menu = false">Cancel</v-btn>
          <v-btn flat
                 color="primary"
                 @click="$refs.menu.save(date)">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-flex>
    <v-btn fab
           dark
           small
           color="blue"
           @click.native="clearField">
      <v-icon dark>add</v-icon>
    </v-btn>

    <v-btn fab
           dark
           small
           color="teal"
           v-on:click.native="nextStep">
      <v-icon dark>check</v-icon>
    </v-btn>

  </span>
</template>

<script>

import VueGoogleAutocomplete from './vue-autocomplete'

export default {

  mounted () {
  },
  components: { VueGoogleAutocomplete },
  name: 'pickup',
  data () {
    return {
      date: null,
      menu: null
    }
  },
  props: ['pickupType', 'deliveryDate'],
  firestore () {
    return {
    }
  },
  watch: {
    deliveryDate: function () {
      this.date = this.deliveryDate
    }
  },
  methods: {
    getAddressData: function (addressData, placeResultData, id) {
      this.address = placeResultData
      this.$emit('cargo', this.pickupType + ': ' + this.address.formatted_address)
      if (this.pickupType === 'Delivery') {
        this.$emit('city', addressData.locality)
      }
    },
    clearField () {
      this.$refs.address.clear()
      this.$refs.address.focus()
    },
    nextStep () {
      this.$emit('cargo', this.pickupType + 'Date: ' + this.date)
      this.$emit('nextStep')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pickup.vue